import { standardRequestWithErrorFlash } from 'shared/utils/request';

export type Payload = {
  text: string;
  tone_descriptor?: string;
  product?: string;
};

export const makeAiRequest = async (
  action: string,
  payload: Payload
): Promise<string> => {
  const { data } = await standardRequestWithErrorFlash.post(
    `/ai_tools/${action}`,
    payload
  );

  return data.updated_text;
};
